// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__5fVKD","inputDescription":"styles_inputDescription__2QtTW"};